import { render, staticRenderFns } from "./FormularioOrdenDos.vue?vue&type=template&id=fe82ede0"
import script from "./FormularioOrdenDos.vue?vue&type=script&lang=js"
export * from "./FormularioOrdenDos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports